export default "__VITE_PUBLIC_ASSET__5c132ff9__"